import React, { useMemo } from 'react'
import injectStyles from 'react-jss'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { getHeaders } from './utils'
import { styles } from './styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Row from './Row'

const AvailabilitiesTable = ({
  data,
  classes,
  bookBa = null,
  showDistance = false,
  orderBy,
  order,
  createSortHandler,
  openRowIds,
  setOpenRowIds,
  highligthedAvailability,
}) => {
  const headers = useMemo(() => getHeaders({ bookBa, showDistance }), [])

  return (
    <div>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              {headers.map(header => (
                <TableCell
                  key={header.id}
                  className={classes.tableHeader}
                  align={header.align}
                >
                  {header.sort ? (
                    <TableSortLabel
                      active={orderBy === header.id}
                      direction={orderBy === header.id ? order : 'asc'}
                      onClick={createSortHandler(header.id)}
                    >
                      {header.name}
                    </TableSortLabel>
                  ) : (
                    header.name
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => (
              <Row
                classes={classes}
                key={row.name}
                bookBa={bookBa}
                showDistance={showDistance}
                row={row}
                openRowIds={openRowIds}
                setOpenRowIds={setOpenRowIds}
                highligthedAvailability={highligthedAvailability}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default injectStyles(styles)(AvailabilitiesTable)
